import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    interpolation: {
      escapeValue: false
    },
    resources: {
      en: { translation: require('./localisation/en.json') },
      fi: { translation: require('./localisation/fi.json') },
      sv: { translation: require('./localisation/sv.json') },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'fi', 'sv'],
  });

export default i18n;